import { Button, Stack, Typography } from '@mui/material';
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { useProviderIgnoredRequestsTable } from '@Modal/hooks/providerIgnoredRequests/useProviderIgnoredRequestsTable';

export const ProviderIgnoredRequestsTitle: React.FC = () => {
  const { providerIgnoredRequestsTableFilters, handleClearProviderIgnoredRequestsTableFilters } =
    useProviderIgnoredRequestsTable();
  const objectVals = Object.values(providerIgnoredRequestsTableFilters);
  const disabled = objectVals.length === 0 || objectVals.every((val) => val === undefined);

  return (
    <AtLocator type="container" name="ProviderTransactionsListTitle">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ paddingBottom: 2 }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h3">Provider Ignored Requests</Typography>
        </Stack>
        <AtLocator type="button" name="clearFilters">
          <Button
            size="large"
            variant="contained"
            disabled={disabled}
            onClick={handleClearProviderIgnoredRequestsTableFilters}
          >
            Clear filters
          </Button>
        </AtLocator>
      </Stack>
    </AtLocator>
  );
};
